import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Error } from 'src/app/models/error';
@Injectable()
export class ModalErrorService {
  private modalOpen = new Subject<Error[]>();
  private modalErrors: any[] = [];

  sharedModalOpen = this.modalOpen.asObservable();

  constructor() {}

  emitModalOpen(newError: Error) {
    this.modalErrors.push(newError);
    this.modalOpen.next(this.modalErrors);
  }

  cleanErrors() {
    this.modalErrors = [];
  }

}